import axios from 'axios';
import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns'
import { hu } from 'date-fns/locale'
import { FaCalendar } from 'react-icons/fa';

import Heading from 'components/Heading.js';
import Content from 'components/Content.js';

import { useConfig } from 'providers/ConfigProvider';

export default function NewsPage(props) {

    const [post, setPost] = useState(null);

    let { slug } = useParams();



    useEffect(() => {
        if (slug != null)
            axios.get(`${global.endpoint}wp-json/wp/v2/posts?slug=${slug}&_embed`)
                .then(res => setPost(res.data[0]))
                .catch(err => console.error(err));
        else setPost(null);
    }, [slug]);

    return (
        <div className={'w-full flex flex-col items-center ' + (props.className || '')}>

            <Heading image={'http://www.webfactor.hu/siloam/wp-content/uploads/2024/06/P1100065.jpg'} title={post ? post.title.rendered : 'Hírek'} />

            {(!post) && <div className='w-full flex flex-col items-center px-site py-16'>
                <div className='w-full max-w-boxed'>
                    <NewsList />
                </div>
            </div>}

            {post && <Content data={post} />}

        </div >
    );
}

export function NewsList(props) {
    const [posts, setPosts] = useState(null);

    useEffect(() => {
        axios.get(`${global.endpoint}wp-json/wp/v2/posts?per_page=100&_embed`)
            .then(res => setPosts(res.data))
            .catch(err => console.error(err));
    }, []);

    return (
        <div className='flex flex-col gap-16'>
            {posts && posts.map((item) => <NewsListItem key={item.id} data={item} />)}
        </div>
    );
}

function NewsListItem(props) {
    const { categories } = useConfig();

    const _d = {
        slug: props.data.slug,
        title: props.data.title.rendered,
        date: props.data.date,
        content: props.data.excerpt.rendered,
        categories: props.data.categories,
        image: (props.data._embedded && props.data._embedded['wp:featuredmedia']) && props.data._embedded['wp:featuredmedia'][0].source_url,
    }

    return (
        <div className='flex flex-col md:flex-row items-start gap-6 md:gap-12'>

            <Link to={'/hirek/' + _d.slug} className='w-full md:w-64'><div className='w-full aspect-video bg-cover bg-black/5' style={{ backgroundImage: 'url(' + _d.image + ')' }} /></Link>

            <div className='flex-1 flex flex-col gap-4'>

                <div className='flex flex-col gap-2'>
                    <div className='text-primary uppercase tracking-wide font-bold text-sm flex flex-col gap-2'>
                        <div className='text-primary uppercase tracking-wide font-bold text-sm flex leading-none divide-x'>
                            {_d.categories.map((item) => <div className='px-2 first:pl-0 last:pr-0' key={item}>{categories.find(obj => obj.id === item)?.name}</div>)}
                        </div>
                        <div className='font-semibold text-neutral-400 flex gap-2 items-center'><FaCalendar className='text-xs opacity-50 mb-0.5' />{format(_d.date, 'yyyy. MMMM d.', { locale: hu })}</div>
                    </div>
                    <Link to={'/hirek/' + _d.slug}><div className='text-2xl lg:text-3xl font-bold uppercase text-stone-600 hover:text-primary transition-colors' dangerouslySetInnerHTML={{ __html: _d.title }} /></Link>
                </div>

                <div className='text-neutral-500 text-sm leading-relaxed line-clamp-2' dangerouslySetInnerHTML={{ __html: _d.content }} />

            </div>
        </div>
    );
}